// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FLW9","left":"styles_left__1tEW1"};